/** Δομή αποθήκευσης ζωγραφισμένης υπογραφής: SVG path + διαστάσεις καμβά. */
export type SignatureData = { d: string; w: number; h: number };

/** Διαβάζει την αποθηκευμένη υπογραφή (JSON) → SignatureData ή null αν μη έγκυρη/κενή. */
export function parseSignature(raw: string | null | undefined): SignatureData | null {
  if (!raw) return null;
  try {
    const o = JSON.parse(raw) as Partial<SignatureData>;
    if (typeof o?.d === 'string' && o.d && Number(o.w) > 0 && Number(o.h) > 0) {
      return { d: o.d, w: Number(o.w), h: Number(o.h) };
    }
  } catch {
    // μη έγκυρο
  }
  return null;
}
